/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_EmailInputs */

const es_footer_email = /** @type {(inputs: Footer_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · info@zarpar.eu`)
};

const gl_footer_email = /** @type {(inputs: Footer_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · info@zarpar.eu`)
};

const en_footer_email = /** @type {(inputs: Footer_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · info@zarpar.eu`)
};

/**
* | output |
* | --- |
* | "Email · info@zarpar.eu" |
*
* @param {Footer_EmailInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_email = /** @type {((inputs?: Footer_EmailInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_EmailInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_email(inputs)
	if (locale === "en") return en_footer_email(inputs)
	return es_footer_email(inputs)
});